<template>
    <div class="mt-5">
        <b-form v-on:submit.prevent="loadData">
        <b-form-input
                placeholder="Search..."
                class="ml-3 mb-2 searchinput"
                v-model="searchText"/></b-form>
        <ul class="list-unstyled pl-3">
            <li class="pt-1 pl-2 row" v-bind:class="{'book-row': row.data.isBook}" v-for="row in rows" :key="row.id">
                <a v-if="!row.data.isBook" href="javascript:void(0)" @click="onClickCategory(row.catdata.id)">{{row.catdata.title}}</a>
                <a v-if="row.data.isBook" href="javascript:void(0)" @click="onClickBook(row.data.id)">{{row.data.title}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
import Vue from 'vue'
export default {
    name: 'book-navigator',
    data: function () {
        return {
            rows: [],
            activeCategoryId: 0,
            searchText: null
        }
    },

    async mounted () {
        this.loadData()
    },
    methods: {
        async loadData () {
            let result = await Vue.API.AmfRequest(
                'iqistic.Booknavigator',
                'getBooksWithPartner',
                [this.activeCategoryId, 0, 0, this.searchText]
            )

            this.rows = result.data
        },
        onClickCategory (categoryId) {
            if (categoryId === this.activeCategoryId) this.activeCategoryId = 0
            else this.activeCategoryId = categoryId
            this.loadData()
        },
        onClickBook (bookId) {
            this.$router.push({ name: 'books-edit', params: { id: bookId } })
        },
    }
}
</script>

<style scoped>
    .row:hover {
        background-color:#333;
    }
    .row a,
    .book-row a {
        color:#FFF;
    }
    .book-row a {
        padding-left:1.5em;
    }
    .book-row {
    }
    .searchinput {
        max-width:13rem;
    }

</style>
